import t, { forwardRef as r } from "react";
import { Box as x, Flex as a } from "@huspy/styled-system/jsx";
const l = r(
  (e, o) => /* @__PURE__ */ t.createElement(x, { ...e, ref: o })
), f = r(
  (e, o) => /* @__PURE__ */ t.createElement(a, { ...e, ref: o })
);
export {
  l as Box,
  f as Flex
};
